import { useState, useCallback } from "react";
import useSWR from "swr";
import { fetcher } from "../lib/api";
import { connectInjected } from "../lib/wallet";

export function useConfig() {
  const { data } = useSWR("/config", fetcher, { revalidateOnFocus: false });
  return data;
}

export function useStats() {
  const { data } = useSWR("/stats", fetcher, { refreshInterval: 10000 });
  return data;
}

export function useWallet() {
  const [address, setAddress] = useState(null);
  const [connecting, setConnecting] = useState(false);

  const connect = useCallback(async () => {
    setConnecting(true);
    try {
      const addr = await connectInjected();
      setAddress(addr);
      return addr;
    } finally {
      setConnecting(false);
    }
  }, []);

  const disconnect = useCallback(() => setAddress(null), []);

  return { address, connect, disconnect, connecting };
}
